import { useEffect, useState } from "react";
import {
  Drawer,
  Grid,
  IconButton,
  Icons,
  Loader,
  PanelHeader,
  Text,
  useToggle,
} from "@pushpress/shared-components";
import { useGetUserSubscriptionQuery } from "./SwitchPlanDrawer-generated.hooks";
import SwitchPlanForm from "./SwitchPlanForm";
import { extractError } from "../../utils/misc";

function SwitchPlanDrawer() {
  const [switchPlanPanelOpened, switchPlanPanelOpenedActions] =
    useToggle(false);
  const [subscriptionUuid, setSubscriptionUuid] = useState("");
  const [userUuid, setUserUuid] = useState("");

  useEffect(() => {
    const handleOpenSwitchPlanPanelToggle = (
      customEvent: CustomEvent<{
        subscriptionUuid: string;
        userUuid: string;
      }>,
    ) => {
      if (
        !switchPlanPanelOpened &&
        customEvent.detail.subscriptionUuid &&
        customEvent.detail.userUuid
      ) {
        setSubscriptionUuid(customEvent.detail.subscriptionUuid);
        setUserUuid(customEvent.detail.userUuid);
        switchPlanPanelOpenedActions.on();
      }
    };

    window.addEventListener(
      "OpenSwitchPlanPanel",
      handleOpenSwitchPlanPanelToggle,
    );

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener(
        "OpenSwitchPlanPanel",
        handleOpenSwitchPlanPanelToggle,
      );
    };
  }, [
    setSubscriptionUuid,
    switchPlanPanelOpened,
    switchPlanPanelOpenedActions,
  ]);

  return (
    <Drawer visible={switchPlanPanelOpened} anchor="right" width="420px">
      <PanelHeader title={`Switch plan`}>
        <PanelHeader.ActionMenu>
          <IconButton
            icon={Icons.X}
            onClick={switchPlanPanelOpenedActions.off}
          />
        </PanelHeader.ActionMenu>
      </PanelHeader>
      <SwitchPlanDrawerContent
        subscriptionUuid={subscriptionUuid}
        userUuid={userUuid}
      />
    </Drawer>
  );
}

type SwitchPlanDrawerContentProps = {
  subscriptionUuid: string;
  userUuid: string;
};

export function SwitchPlanDrawerContent({
  subscriptionUuid,
  userUuid,
}: SwitchPlanDrawerContentProps) {
  const { data, loading, error } = useGetUserSubscriptionQuery({
    variables: {
      getUserSubscriptionInput: {
        userSubscriptionUuid: subscriptionUuid,
      },
    },
  });

  if (loading)
    return (
      <Grid
        container
        item
        alignItems="center"
        justifyContent="center"
        xs={12}
        paddingY={4}
      >
        <Loader />
      </Grid>
    );

  if (error) {
    return (
      <Grid
        container
        item
        alignItems="center"
        justifyContent="center"
        xs={12}
        paddingY={4}
      >
        <Text variant="body-lg">{extractError(error)}</Text>
      </Grid>
    );
  }

  return (
    <SwitchPlanForm
      userSubscription={data?.getUserSubscription}
      userUuid={userUuid}
    />
  );
}

export default SwitchPlanDrawer;
